import * as monthUtils from '@actual-app/core/shared/months';

/**
 * Fecha del editor de movimientos con el formato legible de la app
 * («dom, 4 oct 2026»), en vez del que pinta el selector nativo según el
 * idioma del sistema (en Android en inglés salía 10/04/2026). H09.
 */
export function fechaLegible(
  fechaIso: string,
  locale?: Parameters<typeof monthUtils.format>[2],
): string {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(fechaIso)) return '';
  return monthUtils.format(fechaIso, 'EEE, d MMM yyyy', locale);
}
